/*
 * @FilePath: \uni-preset-vue-vite\src\router\afterEach.js
 * @Date: 2022-10-02 02:29:54
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2024-08-16 14:58:59
 * @Description: 路由后置守卫
 * @item 导出的函数会自动注册
 */

// 示例
export function after(to, from) {
  // console.log(16, 'after->location-->>>', location)
  console.log(`路由后置守卫to:`, to)
  console.log(`路由后置守卫from: `, from)
}
